module.exports = __webpack_public_path__ + "static/media/ærlig.3a3501b1.mp3";